import React from 'react'
import { useMemo } from 'sb-hooks'
import PropTypes from 'prop-types'

import { Accordion } from 'components/_new/ui/Accordion'

import NavListItem from './NavListItem/NavListItem'


const NavList = ({ items, pathname, level, minSubNavLengthToDisplay, closeNav }) => {
  const content = items.map((item, index) => {
    const key = item.dataTestId || item.id || index

    return (
      <NavListItem
        key={key}
        item={item}
        pathname={pathname}
        level={level}
        minSubNavLengthToDisplay={minSubNavLengthToDisplay}
        closeNav={closeNav}
      />
    )
  })

  const node = useMemo(() => {
    const isSubNavExist = items.some(({ subNav }) => subNav && subNav.length >= minSubNavLengthToDisplay)

    return isSubNavExist ? Accordion : 'div'
  }, [ items, minSubNavLengthToDisplay ])

  return React.createElement(node, {}, content)
}

NavList.propTypes = {
  items: PropTypes.array.isRequired,
  closeNav: PropTypes.func.isRequired,
  pathname: PropTypes.string,
  minSubNavLengthToDisplay: PropTypes.number,
  level: PropTypes.oneOf([ 1, 2, 3 ]),
}

NavList.defaultProps = {
  level: 1,
  minSubNavLengthToDisplay: 1,
}


export default React.memo(NavList)
